/**
 * @file 模型库页
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {ArrowUpOutlined} from '@ant-design/icons';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import ModelBaseMenu from '../../components/model-base-menu/ModelBaseMenu';

import ModelBaseList from './components/model-base-list/ModelBaseList';
import usePaddleHubHooks from './modelBaseHooks';
import A from '../../components/a/A';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';


const ModelBase: React.FC = () => {
    const {
        menuList,
        modelList,
        menuActiveKeys,
        menuOpenKeys,
        onMenuActiveChange,
        onMenuOpenChange
    } = usePaddleHubHooks();

    return (
        <div className="page model-base-page">
            <Header />
            <Banner
                title="模型库"
                subtitle={
                    <span>
                        覆盖图像、自然语言处理、推荐等多种方向的官方模型
                        <A
                            className="model-base-page-banner-link"
                            target
                            href="https://github.com/paddlepaddle/models"
                        >
                           GitHub <ArrowUpOutlined className="model-base-page-banner-icon" />
                        </A>
                        <A
                            className="model-base-page-banner-link"
                            target
                            href="https://gitee.com/paddlepaddle/models"
                        >
                           Gitee <ArrowUpOutlined className="model-base-page-banner-icon" />
                        </A>
                        <A
                            className="model-base-page-banner-link"
                            target
                            href="https://www.paddlepaddle.org.cn/install/quick?docurl=/documentation/docs/zh/install/pip/windows-pip.html"
                        >
                           安装飞桨 <ArrowUpOutlined className="model-base-page-banner-icon" />
                        </A>
                    </span>
                }
            />

            <div className="model-base-page-container clear-both">
                <div className="model-base-page-container-left">
                    <ReactStickyPolyfill>
                        <div className="model-base-page-left-menu-wrap">
                            <ModelBaseMenu
                                menuList={menuList}
                                menuActiveKeys={menuActiveKeys}
                                menuOpenKeys={menuOpenKeys}
                                onMenuActiveChange={onMenuActiveChange}
                                onMenuOpenChange={onMenuOpenChange}
                            />
                        </div>
                    </ReactStickyPolyfill>
                </div>
                <div className="model-base-page-container-right">
                    <ModelBaseList modelList={modelList[menuActiveKeys[0] || ''] || []} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ModelBase;
